var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height",attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('su-menu-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }